import { PropertyFieldViewModel } from "../types/property-field.view-model";
import { PropertyFieldValueViewModel } from "../types/property-field-value.view-model";
import { PropertyFieldsFormData } from "../schemas/property-fields-schema";
import type { Json } from "../../../../../../types/supabase";

export interface PropertyFieldApiPayload {
  id?: number;
  label: string;
  placeholder: string | null;
  type: string;
  options: any[];
  data_key: string;
  required: boolean;
  order: number;
  property: number;
  value?: {
    id?: number;
    value: Json | null;
    property_field?: number;
    property: number;
  };
}

export const transformFormDataToApiPayload = (
  formData: PropertyFieldsFormData,
  fields: PropertyFieldViewModel[],
  currentValues: PropertyFieldValueViewModel[],
  propertyId: number
): PropertyFieldApiPayload[] => {
  return fields.map(field => {
    const currentValue = currentValues.find(v => v.data_key === field.data_key);
    const formValue = formData[field.data_key as keyof typeof formData] as Json;

    return {
      label: field.label,
      type: field.type,
      data_key: field.data_key,
      required: field.required ?? false,
      placeholder: field.metadata?.placeholder ?? null,
      options: field.metadata?.options ?? [],
      order: field.metadata?.order ?? 0,
      property: propertyId,
      value:
        formValue !== undefined
          ? {
              id: currentValue?.id,
              value: {
                field: formValue,
              },
              property_field: currentValue?.id,
              property: propertyId,
            }
          : undefined,
    };
  });
};
